<onyx-section
  [heading]="`${I18N}.assignedDrivers`"
  [count]="driversControl.length"
>
  <div class="container">
    <onyx-toggle
      [label]="`${I18N}.assignAll`"
      [(checked)]="assignAllDrivers"
      (click)="assign()"
    ></onyx-toggle>

    <form [formGroup]="form()">
      <onyx-dropdown
        [formControl]="form().controls.selectedDrivers"
        [options]="DRIVERS_SOURCE"
        [multiple]="true"
        (totalItemsChange)="totalDriversCount.set($event)"
        (selectedOptionValuesChange)="drivers.set($event.values)"
        [size]="32"
      ></onyx-dropdown>

      <onyx-table
        [data]="driversList()"
        [columns]="COLUMNS"
        [tableShadow]="false"
        [rowSize]="48"
        [notFound]="NOT_FOUND"
        (rowClick)="openDriverModal($event.item)"
        [(pagination)]="pagination"
      ></onyx-table>
    </form>
  </div>
</onyx-section>
